import { LoanFormatState } from '../js/app-store/loanFormat/loanFormatReducer';

export type LoanFormatDto = 'EAUDIOBOOKS' | 'EBOOKS' | 'EMAGAZINES' | 'ALL';

export const mapLoanFormatStateToDto = (loanFormatState: LoanFormatState): LoanFormatDto => {
    const loanFormatKey = loanFormatState.requestKey;

    switch (loanFormatKey) {
        case 'EBOOKS':
            return 'EBOOKS';
        case 'EAUDIOBOOKS':
            return 'EAUDIOBOOKS';
        case 'EPRESS':
        case 'EMAGAZINES':
            return 'EMAGAZINES';
        default:
            return 'ALL';
    }
};
